import { createSlice } from '@reduxjs/toolkit';
import VwStkdepotalepbaslikDTO from 'src/models/StokEczane/DepoTalepleri/VwStkdepotalepbaslikDTO';
import VwStkdepotalepdetayDTO from 'src/models/StokEczane/DepoTalepleri/VwStkdepotalepdetayDTO';
import VwKullaniciDepotanimlariDTO from 'src/models/StokEczane/DepoTanimlari/VwKullaniciDepotanimlariDTO';
import MapReducerPayloads from 'src/models/store/MapReducerPayloads';
import api from 'src/services/core/api';
import { DepoTalepApi, useGetDepoTalepDetayListQuery } from 'src/services/StokEczane/DepoTalepApi';
import { depoTanimApi } from 'src/services/StokEczane/DepotanimApi';
import { helper } from 'src/utils/helper';

class DepoTalepAramaKriterleri {
  basTarih: string;
  bitTarih: string;
  depoTanimId: number;
  depoAdi: string;
  talepDepoTanimId: number;
  servisId?: number;
  refetch: boolean;
  islemDurumChck: boolean;
}

interface IDepoTalepState {
  aramaKriterleri: DepoTalepAramaKriterleri,
  depoTalepRecord: VwStkdepotalepbaslikDTO,
  talepDetayList: Array<VwStkdepotalepdetayDTO>,
  talepDetayRecord: VwStkdepotalepdetayDTO,
  detListRefetch: boolean
  talepList: Array<VwStkdepotalepbaslikDTO>,
  talepGiriseGore: string,
  mevcuduOlmayanlariGoster:string,
  kullaniciDepoList: Array<VwKullaniciDepotanimlariDTO>,
}

const DepoTalepSlice = createSlice<IDepoTalepState,MapReducerPayloads<IDepoTalepState,
    {
      // setState: IDepoTalepState;
      setAramaKriterleri: DepoTalepAramaKriterleri;
      setDepoTalepRecord: VwStkdepotalepbaslikDTO;
      setDepoTalepDetayList: Array<VwStkdepotalepdetayDTO>
      setTalepDetayRecord: VwStkdepotalepdetayDTO
      setDetayListRefetch: boolean;
      setDepoTalepList: Array<VwStkdepotalepbaslikDTO>,
      setTalepGiriseGore: string,
      setMevcuduOlmayanlariGoster:string,
      setKullaniciDepoList:  Array<VwKullaniciDepotanimlariDTO>
    }
  >
>({
  name: 'UrunTanim',
  initialState: {
    aramaKriterleri: {
      ...new DepoTalepAramaKriterleri() ,
      refetch: false
    },
    depoTalepRecord: new VwStkdepotalepbaslikDTO(),
    talepDetayList: [],
    talepDetayRecord: new VwStkdepotalepdetayDTO(),
    detListRefetch: false,
    talepList: [],
    talepGiriseGore: "H",
    mevcuduOlmayanlariGoster:"H",
    kullaniciDepoList: [],
  },
  reducers:{
    setAramaKriterleri : (state,action) =>{
      state.aramaKriterleri = action.payload
    },
    setDepoTalepRecord: (state,action) => {
      state.depoTalepRecord = action.payload
    },
    setDepoTalepDetayList: (state, action) => {
      state.talepDetayList = action.payload
    },
    setTalepDetayRecord: (state, action) => {
      state.talepDetayRecord = action.payload
    },
    setDetayListRefetch: (state, action) => {
      state.detListRefetch = action.payload
    },
    setDepoTalepList: (state, action) => {
      state.talepList = action.payload
    },
    setTalepGiriseGore: (state, action) => {
      state.talepGiriseGore = action.payload
    },
    setMevcuduOlmayanlariGoster: (state, action) => {
      state.mevcuduOlmayanlariGoster = action.payload
    },
    setKullaniciDepoList: (state, action) => {
      state.kullaniciDepoList = action.payload
    },
  },
  extraReducers:(builder) => {
    builder.addMatcher(DepoTalepApi.endpoints.GetDepoTalepDetayList.matchFulfilled, (state, action) => {
      state.talepDetayList = action.payload;
      return state;
    })
    builder.addMatcher(DepoTalepApi.endpoints.GetDepoTalepList.matchFulfilled, (state, action) => {
      state.talepList = action.payload;
      return state;
    })
    builder.addMatcher(depoTanimApi.endpoints.GetKullaniciDepoTanimList.matchFulfilled, (state, action) => {
      state.kullaniciDepoList = action.payload as Array<VwKullaniciDepotanimlariDTO>;
      return state;
    })
  }
});
export default DepoTalepSlice;
